module.exports = __webpack_public_path__ + "img/image-5.32df535e.jpeg";